import numeral from 'numeral';

import 'numeral/locales';

const defaultLocaleData = numeral.localeData('es');

export const DEFAULT_NUMERAL_LOCALE = 'es-cl';

export const LOCALE_DATA = [
  {
    code: 'es-cl',
    locale: { ...defaultLocaleData }
  },
  {
    code: 'es-ar',
    locale: { ...defaultLocaleData }
  },
  {
    code: 'es-gt',
    locale: {
      ...defaultLocaleData,
      delimiters: {
        thousands: ',',
        decimal: '.'
      }
    }
  },
  {
    code: 'es-mx',
    locale: {
      ...defaultLocaleData,
      delimiters: {
        thousands: ',',
        decimal: '.'
      }
    }
  },
  {
    code: 'es-cr',
    locale: {
      ...defaultLocaleData,
      delimiters: {
        thousands: ',',
        decimal: '.'
      }
    }
  }
];

// Falls back to the default locale so that a country without its own registered locale degrades to
// chilean formatting instead of throwing on every formatted price.
export const getNumeralLocale = (isoCountry) => {
  const code = `es-${String(isoCountry || '').toLowerCase()}`;

  return numeral.locales[code] ? code : DEFAULT_NUMERAL_LOCALE;
};
